/**
 * Global Semantic Status & Badge Color System
 * Unified soft-tint pill format matching Pay Heads and Core Payroll master designs.
 * (e.g. Earning -> bg-emerald-500/10 text-emerald-600, Deduction -> bg-amber-500/10 text-amber-600)
 */

export const STATUS_COLORS = {
  // Emerald / Positive / Approved / Present / Earning
  EARNING: 'bg-emerald-500/10 text-emerald-600',
  APPROVED: 'bg-emerald-500/10 text-emerald-600',
  ACTIVE: 'bg-emerald-500/10 text-emerald-600',
  PRESENT: 'bg-emerald-500/10 text-emerald-600',
  P: 'bg-emerald-500/10 text-emerald-600',

  // Amber / Warning / Pending / Half-day / Deduction / Late In
  DEDUCTION: 'bg-amber-500/10 text-amber-600',
  STATUTORY_DEDUCTION: 'bg-amber-500/10 text-amber-600',
  PENDING: 'bg-amber-500/10 text-amber-600',
  'PENDING REVIEW': 'bg-amber-500/10 text-amber-600',
  HALF_DAY: 'bg-amber-500/10 text-amber-600',
  HF: 'bg-amber-500/10 text-amber-600',
  LATE_IN: 'bg-amber-500/10 text-amber-600',

  // Rose / Error / Rejected / Absent / Inactive
  REJECTED: 'bg-rose-500/10 text-rose-600',
  ABSENT: 'bg-rose-500/10 text-rose-600',
  A: 'bg-rose-500/10 text-rose-600',
  INACTIVE: 'bg-rose-500/10 text-rose-600',

  // Purple / Leave / On Leave
  LEAVE: 'bg-purple-500/10 text-purple-600',
  L: 'bg-purple-500/10 text-purple-600',
  ON_LEAVE: 'bg-purple-500/10 text-purple-600',

  // Indigo / Weekly Off
  WEEKLY_OFF: 'bg-indigo-500/10 text-indigo-600',
  WO: 'bg-indigo-500/10 text-indigo-600',

  // Blue / Holiday / Other
  HOLIDAY: 'bg-blue-500/10 text-blue-600',
  HD: 'bg-blue-500/10 text-blue-600',
  ARCHIVE: 'bg-slate-500/10 text-slate-600',
};

export function getStatusBadgeClass(status) {
  if (!status) return 'bg-surface-container-high text-on-surface-variant';
  const clean = String(status).trim().toUpperCase();
  const underscoreKey = clean.replace(/[\s-]+/g, '_');
  return STATUS_COLORS[underscoreKey] || STATUS_COLORS[clean] || 'bg-primary/10 text-primary';
}
